import { styled } from '@mui/material';

export const GaitEventsAddPatientFormWrapper = styled('div')(({ theme }) => ({
    border: '1px solid grey',
    borderColor: theme.palette.grey[300],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
}));
